import { membresias } from "@/lib/membresias";

export default function Membresias() {
  return (
    <section aria-label="Membresías" className="bg-white border-t border-slate-200">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-10 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
        <p
          className="text-[#0B1F3A] font-bold text-base md:text-lg text-center md:text-left"
          style={{ fontFamily: "'Sora', sans-serif" }}
        >
          Este medio es miembro de:
        </p>
        <div className="flex flex-wrap items-stretch justify-center gap-5 md:gap-8">
          {membresias.map((m) => (
            <a
              key={m.sigla}
              href={m.href}
              target="_blank"
              rel="noopener noreferrer"
              title={m.nombre}
              className="w-40 sm:w-56 flex flex-col items-center gap-3 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-sm px-4 py-4 transition-all cursor-pointer"
            >
              <span className="h-20 sm:h-24 flex items-center justify-center">
                <img src={m.logo} alt={`${m.sigla} — ${m.nombre}`} loading="lazy" className="max-h-full max-w-full object-contain" />
              </span>
              <span
                className="text-slate-500 text-xs text-center leading-snug"
                style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
              >
                {m.nombre}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
